import React from 'react';
import { Link } from 'react-router-dom';
import DailyChallenge from '../components/DailyChallenge';

function Home() {
  return (
    <div>
      {/* 2026 Congratulations Banner (temporary — remove once no longer relevant) */}
      <div style={{
        background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
        color: '#5a3e1b',
        padding: '12px 20px',
        borderRadius: '10px',
        marginBottom: '20px',
        textAlign: 'center',
        fontSize: '15px',
        fontWeight: '600',
        boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
      }}>
        🎉 Congratulations to all 2026 NSW Selective students on your results — you should be proud! Now enrolling students for the 2027 exam.
      </div>

      {/* Hero Section with Countdown */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '20px', marginBottom: '30px' }}>
        {/* Main Hero */}
        <div className="card" style={{ 
          textAlign: 'center', 
          padding: '60px 24px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ fontSize: '56px', marginBottom: '10px' }}>🎓</div>
            <h1 style={{ fontSize: '48px', marginBottom: '20px', textShadow: '2px 2px 4px rgba(0,0,0,0.2)' }}>
              Master Your Placement Test
            </h1>
            <p style={{ fontSize: '20px', marginBottom: '40px', opacity: '0.95' }}>
              Smart practice tests for NSW Selective High School & Opportunity Class (OC)
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/exams">
                <button style={{ 
                  fontSize: '18px', 
                  padding: '16px 32px',
                  background: 'white',
                  color: '#667eea',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                }}
                >
                  🚀 Start Free Practice
                </button>
              </Link>
            </div>
          </div>
          {/* Decorative circles */}
          <div style={{ position: 'absolute', top: '-50px', right: '-50px', width: '200px', height: '200px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }}></div>
          <div style={{ position: 'absolute', bottom: '-30px', left: '-30px', width: '150px', height: '150px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }}></div>
        </div>

        {/* Daily Challenge Hub */}
        <div className="card" style={{ 
          padding: '20px',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <DailyChallenge />
        </div>
      </div>

      {/* Stats Section */}
      <div className="card" style={{ 
        marginBottom: '30px',
        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        color: 'white',
        padding: '40px 30px'
      }}>
        <h2 style={{ fontSize: '32px', marginBottom: '30px', textAlign: 'center' }}>
          Join Students Preparing for Success 🌟
        </h2>
        
        {/* No Credit Card Required Banner */}
        <div style={{ 
          background: 'rgba(255, 255, 255, 0.95)', 
          padding: '20px 30px', 
          borderRadius: '12px', 
          marginBottom: '35px',
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <div style={{ fontSize: '32px', marginBottom: '10px' }}>🎉</div>
          <h3 style={{ fontSize: '24px', color: '#4f46e5', marginBottom: '10px', fontWeight: 'bold' }}>
            100% Free - No Credit Card Required!
          </h3>
          <p style={{ fontSize: '18px', color: '#666', margin: 0 }}>
            Simply register with your email and start practicing immediately
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '25px', marginBottom: '35px' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '5px' }}>15+</div>
            <p style={{ opacity: '0.9', fontSize: '16px' }}>Free Practice Tests</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '5px' }}>2</div>
            <p style={{ opacity: '0.9', fontSize: '16px' }}>Exam Programs (Selective & OC)</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '5px' }}>∞</div>
            <p style={{ opacity: '0.9', fontSize: '16px' }}>Instant Expert Feedback</p>
          </div>
        </div>
        <div style={{ borderTop: '2px solid rgba(255,255,255,0.3)', paddingTop: '30px' }}>
          <h3 style={{ fontSize: '24px', marginBottom: '20px', textAlign: 'center' }}>Why PrepSmart?</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '25px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>💰</div>
              <h4 style={{ fontSize: '18px', marginBottom: '8px' }}>Affordable</h4>
              <p style={{ opacity: '0.9', fontSize: '14px' }}>Quality education for everyone</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>💡</div>
              <h4 style={{ fontSize: '18px', marginBottom: '8px' }}>Smart Feedback</h4>
              <p style={{ opacity: '0.9', fontSize: '14px' }}>Instant, personalized feedback on every answer</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>📊</div>
              <h4 style={{ fontSize: '18px', marginBottom: '8px' }}>Track Progress</h4>
              <p style={{ opacity: '0.9', fontSize: '14px' }}>See your improvement over time</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>🎯</div>
              <h4 style={{ fontSize: '18px', marginBottom: '8px' }}>Exam-Focused</h4>
              <p style={{ opacity: '0.9', fontSize: '14px' }}>Designed for NSW Selective & OC Tests</p>
            </div>
          </div>
        </div>
      </div>

      {/* Premium Features Showcase */}
      <div className="card" style={{ 
        marginBottom: '30px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '50px 30px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>⭐</div>
            <h2 style={{ fontSize: '36px', marginBottom: '15px' }}>Unlock Premium Features</h2>
            <p style={{ fontSize: '20px', opacity: '0.95', maxWidth: '700px', margin: '0 auto' }}>
              Take your preparation to the next level with our comprehensive Premium Bundle
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '25px', marginBottom: '40px' }}>
            {/* Feature 1 */}
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              padding: '30px', 
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ fontSize: '56px', marginBottom: '15px', textAlign: 'center' }}>📚</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', textAlign: 'center' }}>100+ Topic Tests</h3>
              <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.6', textAlign: 'center' }}>
                Master specific skills with focused practice tests covering Algebra, Geometry, Comprehension, Logic Puzzles, and more
              </p>
            </div>

            {/* Feature 2 */}
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              padding: '30px', 
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ fontSize: '56px', marginBottom: '15px', textAlign: 'center' }}>✍️</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', textAlign: 'center' }}>Writing Studio</h3>
              <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.6', textAlign: 'center' }}>
                Practice creative writing with expert feedback. Get line-by-line suggestions to improve your writing skills
              </p>
            </div>

            {/* Feature 3 */}
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              padding: '30px', 
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ fontSize: '56px', marginBottom: '15px', textAlign: 'center' }}>📊</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', textAlign: 'center' }}>Advanced Analytics</h3>
              <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.6', textAlign: 'center' }}>
                Track your progress with detailed performance analytics. Identify strengths and weaknesses to focus your study time
              </p>
            </div>

            {/* Feature 4 */}
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              padding: '30px', 
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ fontSize: '56px', marginBottom: '15px', textAlign: 'center' }}>🎯</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', textAlign: 'center' }}>Expert Feedback System</h3>
              <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.6', textAlign: 'center' }}>
                Get instant, detailed explanations for every question. Learn from mistakes with personalized feedback
              </p>
            </div>

            {/* Feature 5 */}
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              padding: '30px', 
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ fontSize: '56px', marginBottom: '15px', textAlign: 'center' }}>🎯</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', textAlign: 'center' }}>Unlimited Access</h3>
              <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.6', textAlign: 'center' }}>
                Practice as much as you want with unlimited test attempts. No restrictions, no limits on your learning
              </p>
            </div>

            {/* Feature 6 */}
            <div style={{ 
              background: 'rgba(255,255,255,0.15)', 
              padding: '30px', 
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{ fontSize: '56px', marginBottom: '15px', textAlign: 'center' }}>💰</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', textAlign: 'center' }}>Best Value</h3>
              <p style={{ fontSize: '16px', opacity: '0.95', lineHeight: '1.6', textAlign: 'center' }}>
                Only $75 AUD. That's less than the cost of a single tutoring session!
              </p>
            </div>
          </div>

          <div style={{ textAlign: 'center' }}>
            <Link to="/pricing" onClick={() => window.scrollTo(0, 0)}>
              <button style={{ 
                fontSize: '20px', 
                padding: '18px 48px',
                background: 'white',
                color: '#667eea',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
              }}
              >
                View Premium Plans →
              </button>
            </Link>
          </div>
        </div>

        {/* Decorative elements */}
        <div style={{ position: 'absolute', top: '-100px', right: '-100px', width: '300px', height: '300px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }}></div>
        <div style={{ position: 'absolute', bottom: '-80px', left: '-80px', width: '250px', height: '250px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }}></div>
      </div>

      {/* Test Programs */}
      <h2 style={{ fontSize: '32px', marginBottom: '10px', textAlign: 'center', color: '#4f46e5' }}>
        Two Exam Programs, One Platform 📚
      </h2>
      <p style={{ textAlign: 'center', color: '#1f2937', marginBottom: '30px', fontSize: '16px' }}>
        Whether your child is preparing for Selective High School or Opportunity Class, we've got them covered
      </p>

      {/* Programs Side by Side — OC first */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginBottom: '30px' }}>
        {/* OC Program */}
        <div style={{ 
          padding: '30px', 
          borderLeft: '6px solid #10b981',
          background: 'rgba(255,255,255,0.88)',
          borderRadius: '16px',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease',
          cursor: 'default'
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 16px 32px rgba(0,0,0,0.18)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
            <span style={{ fontSize: '32px' }}>📚</span>
            <div>
              <h3 style={{ fontSize: '22px', color: '#10b981', marginBottom: '4px' }}>Opportunity Class (OC)</h3>
              <p style={{ color: '#666', margin: 0, fontSize: '13px' }}>Year 4 → Year 5/6 Entry • 3 Subjects</p>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div style={{ background: '#eef2ff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>🔢</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Mathematics</div>
            </div>
            <div style={{ background: '#ecfdf5', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>📖</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Reading</div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px', marginTop: '10px' }}>
            <div style={{ background: '#fef3c7', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>🧠</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Thinking Skills</div>
            </div>
          </div>
        </div>

        {/* Selective Program */}
        <div style={{ 
          padding: '30px', 
          borderLeft: '6px solid #4f46e5',
          background: 'rgba(255,255,255,0.88)',
          borderRadius: '16px',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease',
          cursor: 'default'
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 16px 32px rgba(0,0,0,0.18)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
            <span style={{ fontSize: '32px' }}>🏫</span>
            <div>
              <h3 style={{ fontSize: '22px', color: '#4f46e5', marginBottom: '4px' }}>Selective High School</h3>
              <p style={{ color: '#666', margin: 0, fontSize: '13px' }}>Year 6 → Year 7 Entry • 4 Subjects</p>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div style={{ background: '#eef2ff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>🔢</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Mathematics</div>
            </div>
            <div style={{ background: '#ecfdf5', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>📖</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Reading</div>
            </div>
            <div style={{ background: '#fef3c7', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>🧠</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Thinking Skills</div>
            </div>
            <div style={{ background: '#fce7f3', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '4px' }}>✍️</div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '13px' }}>Writing</div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="card" style={{ 
        textAlign: 'center', 
        padding: '50px 30px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}>
        <h2 style={{ fontSize: '36px', marginBottom: '15px' }}>Ready to Excel? 🚀</h2>
        <p style={{ fontSize: '18px', marginBottom: '30px', opacity: '0.95' }}>
          Join students preparing for NSW Selective & OC placement exams
        </p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/exams">
            <button style={{ 
              fontSize: '20px', 
              padding: '18px 40px',
              background: 'white',
              color: '#667eea',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            >
              Start Practicing Now
            </button>
          </Link>
          <Link to="/about-selective-tests">
            <button style={{ 
              fontSize: '20px', 
              padding: '18px 40px',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '2px solid white',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            >
              About Selective Test
            </button>
          </Link>
          <Link to="/about-oc-tests">
            <button style={{ 
              fontSize: '20px', 
              padding: '18px 40px',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '2px solid white',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            >
              About OC Test
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
